import React from 'react';
import { choice } from './choiceStyles';
import { EQUIPMENT_OPTIONS } from '../../../utils/loadingEquipment';

// Flervalgspiller for lasteutstyr. Tippi foreslår utstyr, men bestilleren kan velge fritt. Valgte piller har ✓.
export default function EquipmentChips({ value, onToggle }) {
  return (
    <div role="group" aria-label="Hva slags lasteutstyr trengs">
      <span style={choice.label}>Hva slags utstyr? Velg ett eller flere</span>
      <div style={choice.pills}>
        {EQUIPMENT_OPTIONS.map(o => {
          const on = value.includes(o.value);
          return (
            <button key={o.value} type="button" aria-pressed={on} onClick={() => onToggle(o.value)}
                    style={{ ...choice.pill, ...(on ? choice.pillOn : {}) }}>
              {on && <span aria-hidden="true">✓ </span>}{o.label}
            </button>
          );
        })}
      </div>
      <div style={choice.hint}>Tippi har foreslått utstyr ut fra lasten. Du kan endre valget.</div>
    </div>
  );
}
